export const GRIDGIO_ISSUES = [
  { id: 'ISSUE-01', name: '균열', description: '표면에 선형으로 갈라짐이 발생한 상태' },
  { id: 'ISSUE-02', name: '균열부 누수 백태', description: '균열을 따라 누수 또는 백태가 발생한 상태' },
  { id: 'ISSUE-03', name: '망상균열', description: '표면에 그물망 형태의 균열이 발생한 상태' },
  { id: 'ISSUE-04', name: '철근노출', description: '피복이 손상되어 철근이 외부로 노출된 상태' },
  { id: 'ISSUE-05', name: '파손·박리·박락', description: '표면이나 단면 일부가 떨어지거나 깨진 상태' },
  { id: 'ISSUE-06', name: '재료분리·골재분리', description: '재료 또는 골재가 고르게 결합되지 않은 상태' },
  { id: 'ISSUE-07', name: '들뜸·층분리', description: '표면이나 내부 층 사이가 분리된 상태' },
  { id: 'ISSUE-08', name: '부식·녹발생', description: '금속 부재에 부식 또는 녹이 발생한 상태' },
  { id: 'ISSUE-09', name: '누수(흔적)', description: '물이 새거나 누수 흔적이 확인된 상태' },
  { id: 'ISSUE-10', name: '백태', description: '수분 이동으로 표면에 흰 침전물이 발생한 상태' },
  { id: 'ISSUE-11', name: '요철', description: '표면이 고르지 않고 돌출 또는 함몰된 상태' },
  { id: 'ISSUE-12', name: '변형·좌굴', description: '부재의 형상이 변하거나 휘어진 상태' },
  { id: 'ISSUE-13', name: '편칭·공동', description: '부재가 치우치거나 내부에 빈 공간이 발생한 상태' },
  { id: 'ISSUE-14', name: '퇴적', description: '토사나 이물질이 쌓인 상태' },
  { id: 'ISSUE-15', name: '세굴 및 침식', description: '물의 흐름 등으로 재료가 깎이거나 유실된 상태' },
  { id: 'ISSUE-16', name: '기타', description: '지정된 유형에 포함되지 않는 점검 사항' },
] as const;

export const getGridgioIssue = (issueId: string | null) => GRIDGIO_ISSUES.find((issue) => issue.id === issueId);
